import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import ModuleList from '../../../layout/ModuleList';
import {
  BUS_ASSIGNMENT_SCHEDULE_PATH,
  NEW_BUS_ASSIGNMENT_SCHEDULE_PATH,
} from '../../../../config/paths';
import {
  clearBusAssignmentSchedules,
  getBusAssignmentSchedules,
} from '../../../../actions/bus/BusAssignmentSchedule';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { BUS_ASSIGNMENT_SCHEDULE_COLUMNS } from '../../../../config/columns';

const BusAssignmentSchedules = ({
  breadcrumbs,
  loading,
  dispatchGetBusAssignmentSchedules,
  dispatchClearBusAssignmentSchedules,
  busAssignmentSchedules,
}) => {
  useLayoutEffect(() => () => dispatchClearBusAssignmentSchedules(), []);

  const data = busAssignmentSchedules.get('content') || [];
  const pages = busAssignmentSchedules.get('totalPages') || null;
  const defaultPageSize =
    busAssignmentSchedules.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Asignación de Rutas"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_BUS_ASSIGNMENT_SCHEDULE_PATH}
      tableStructure={{
        columns: BUS_ASSIGNMENT_SCHEDULE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetBusAssignmentSchedules,
        modelPath: BUS_ASSIGNMENT_SCHEDULE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

BusAssignmentSchedules.propTypes = {
  breadcrumbs: PropTypes.arrayOf(breadcrumbsPropTypes).isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetBusAssignmentSchedules: PropTypes.func.isRequired,
  dispatchClearBusAssignmentSchedules: PropTypes.func.isRequired,
  busAssignmentSchedules: PropTypes.instanceOf(Immutable.Map).isRequired,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Asignación de Rutas',
      href: '',
    },
  ],
  busAssignmentSchedules: BusUnit.BusAssignmentSchedule.getIn([
    'all',
    'content',
  ]),
  loading: BusUnit.BusAssignmentSchedule.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetBusAssignmentSchedules: getBusAssignmentSchedules,
  dispatchClearBusAssignmentSchedules: clearBusAssignmentSchedules,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusAssignmentSchedules);
